<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title class="cabecalho stickyTitle">
                <v-icon large left>mdi-file-tree</v-icon>
                <span class="title font-weight-light">Plano de Contas</span>
                <v-spacer/>
                <v-text-field v-model="search" label="Pesquisa rápida" clearable single-linehide-details/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Atualizar()">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>Atualizar</span>
                </v-tooltip>                
            </v-card-title>

            <v-card-text>
                <v-treeview hoverable return-object open-all item-key="descricao" item-text="descricao" :items="lista" :open.sync="open" item-children="itens" :search="search">
                    <template slot="label" slot-scope="{ item }">
                        <v-layout v-if="item.id > 0">
                            <v-icon small @click="Novo(item)" v-if="item['itens']">mdi-plus-circle</v-icon>
                            <v-icon small @click="Editar(item)">mdi-pencil</v-icon>
                            <v-icon small @click="Excluir(item)" class="mr-2">mdi-delete</v-icon>
                            <span :style="item[`ativo`] == false ? 'color: red' : ItensAtivos(item) ? 'color: red' : ''">{{ item.descricao }}</span>
                        </v-layout>
                        <v-layout v-else>
                            <v-icon small class="mr-2">mdi-home</v-icon>
                            <v-icon small @click="Novo(item)" class="mr-2">mdi-plus-circle</v-icon>
                            <span>{{ item.descricao }}</span>
                        </v-layout>
                    </template>
                </v-treeview>
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialogPlanoConta" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialogPlanoConta = false"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Plano de Contas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="SalvarPlanoConta()" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-form ref="formPlanoConta" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-text-field v-model="planoConta.nome" label="Nome" :rules="fieldRules" :counter="60" maxlength="60"/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="planoConta.tipo" label="Tipo" :items="tipoPlanoContas" :rules="fieldRules" item-value="key" item-text="value"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPlanoContaItem" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialogPlanoContaItem = false"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Item do Plano de Contas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="SalvarPlanoContaItem()" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-form ref="formPlanoContaItem" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="planoContaItem.nome" label="Nome" :rules="fieldRules" :counter="60" maxlength="60"/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="planoContaItem.criterioAssociacaoContabil" label="Critério de Associação Contábil" :items="criteriosAssociacaoContabil" :rules="fieldRules" item-value="value" item-text="text"/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-switch v-model="planoContaItem.ativo" label="Ativo"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="planoContaItem.criterioAssociacaoContabil === 'U'" cols="12">
                            <v-select v-model="planoContaItem.planoContaContabilId" label="Conta Contábil" :items="planoContaContabeis" clearable item-value="id" item-text="codigoNome"/>
                        </v-col>
                        <v-col v-if="planoContaItem.criterioAssociacaoContabil === 'R'" cols="12" md="6">
                            <v-select v-model="planoContaItem.planoContaContabilLivreId" label="Conta Contábil para recursos Livres" :items="planoContaContabeis" :rules="fieldRules" item-value="id" item-text="codigoNome"/>
                        </v-col>
                        <v-col v-if="planoContaItem.criterioAssociacaoContabil === 'R'" cols="12" md="6">
                            <v-select v-model="planoContaItem.planoContaContabilRestritoId" label="Conta Contábil para recursos Restritos" :items="planoContaContabeis" :rules="fieldRules" item-value="id" item-text="codigoNome"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            </v-card>
        </v-dialog>

    </master-page>
</template>
<script>
import PlanoContaService from '../../../core/services/financeiro/PlanoContaService';
// import PlanoContaItemService from '../../../core/services/financeiro/PlanoContaItemService';
import PlanoContaContabilService from '../../../core/services/financeiro/PlanoContaContabilService';
import TipoPlanoContaEnumService from '../../../core/services/financeiro/TipoPlanoContaEnumService';
import PlanoConta from '../../../core/domain/financeiro/PlanoConta';
import PlanoContaItem from '../../../core/domain/financeiro/PlanoContaItem';

export default {
    data() {
        return {
            service: new PlanoContaService(),
            // serviceItem: new PlanoContaItemService(),
            planoConta: new PlanoConta(),
            planoContaItem: new PlanoContaItem(),
            totalLista: 0,
            lista: [],
            tipoPlanoContas: [],
            planoContaContabeis: [],
            criteriosAssociacaoContabil: [
                { value: 'U', text: 'Conta Contábil Única' },
                { value: 'R', text: 'Por Restrição dos Recursos' }
            ],
            dialogPlanoConta: false,
            dialogPlanoContaItem: false,
            loading: true,
            valid: true,
            search: '',
            open: [0, 1],
            fieldRules: [
                v => !!v || 'Campo obrigatório'
            ],
            nomePai: '',
            tipoItem: 'Novo Plano de Contas'
        }
    },
    mounted() {
        this.Atualizar();

        let tipoPlanoContaEnumService = new TipoPlanoContaEnumService();
        tipoPlanoContaEnumService.Listar().then(
            res => {
                this.tipoPlanoContas = res.data;
            },
            err => {
                this.$swal('Aviso', err.message, 'error')
            }
        );

        let planoContaContabilService = new PlanoContaContabilService();
        planoContaContabilService.Listar().then(
            res => {
                this.planoContaContabeis = res.data.items.filter(x => x.tipoConta === 'A');
            },
            err => {
                this.$swal('Aviso', err.message, 'error')}
        );
    },
    methods: {
        ItensAtivos(item){
            if(!item.itens){
                return false;
            }
            return item.itens.every((x) => {
                return !x.ativo;
            });
        },
        Novo(item){
            if(item.id === -1){
                this.planoConta = new PlanoConta();
                this.dialogPlanoConta = true; 
            }
            else{
                this.planoContaItem = new PlanoContaItem({
                    planoContaId: item.id
                });
                
                this.dialogPlanoContaItem = true;
            }
        },
        Atualizar(){
            this.Listar();
        },
        Editar(item) {

            if (item.planoContaId){
                
                this.planoContaItem = new PlanoContaItem(item);
                this.dialogPlanoContaItem = true;

                if ('formPlanoContaItem' in this.$refs)
                    this.$refs.formPlanoContaItem.resetValidation();

                //this.nomePai = pai ? pai.codigoDescricao : 'RAIZ';
            }
            else {
                this.planoConta = new PlanoConta(item);
                this.dialogPlanoConta = true;

                if ('formPlanoConta' in this.$refs)
                    this.$refs.formPlanoConta.resetValidation();
            }
        },
        Excluir(item) {
            this.$swal({
                title: 'Atenção!',
                text: 'Tem certeza que deseja excluir o registro atual?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    if (item.planoContaId){
                        return this.service.DeletePlanoContaItem(item.planoContaId, item.id).then(
                            res => {
                                if (res.status == 200){
                                    return res;
                                }
                            }, 
                            err => this.$swal('Aviso', err.response.data, 'error')
                        );
                    }
                    else {
                        return this.service.Excluir(item.id).then(
                            res => {
                                if (res.status == 200){
                                    return res;
                                }
                            }, 
                            err => this.$swal('Aviso', err.response.data, 'error')
                            );
                    }

                    },
                allowOutsideClick: () => !this.$swal.isLoading()
            })
            .then((result) => {
                if(result.value) {
                    this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                    this.Atualizar();
                }
            })

        },
        SalvarPlanoConta(){

            if (this.$refs.formPlanoConta.validate()) {

                this.service.Salvar(this.planoConta).then(
                    res => {
                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.Atualizar();
                        }, 
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title || err.response.data, 'warning')
                            }
                            else {
                                this.$swal('Aviso', err.response.data, 'error')
                            }
                        }
                    )
                
                this.dialogPlanoConta = false;
            }

        },
        SalvarPlanoContaItem(){

            if (this.$refs.formPlanoContaItem.validate()) {

                this.planoContaItem.planoContaContabil = null;
                this.planoContaItem.planoContaContabilLivre = null;
                this.planoContaItem.planoContaContabilRestrito = null;
                if (this.planoContaItem.criterioAssociacaoContabil === 'U') {
                    this.planoContaItem.planoContaContabilLivreId = null;
                    this.planoContaItem.planoContaContabilRestritoId = null;
                } else {
                    this.planoContaItem.planoContaContabilId = null;
                }

                (this.planoContaItem.id > 0 ? this.service.PutPlanoContaItem(this.planoContaItem.planoContaId, this.planoContaItem.id, this.planoContaItem) : this.service.PostPlanoContaItem(this.planoContaItem.planoContaId, this.planoContaItem)).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.Atualizar();
                    }, 
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title || err.response.data, 'warning')
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                )
                
                this.dialogPlanoContaItem = false;
            }

        },
        Listar(){
            this.loading = true;
            this.service.ListarTudo("Itens.PlanoContaContabil, Itens.PlanoContaContabilLivre, Itens.PlanoContaContabilRestrito").then(
                res => {
                    let raiz = new PlanoConta({
                        id: -1,
                        descricao: 'RAIZ',
                        itens: (res.data.items.filter(x => x.id > 0)).sort((a,b) => {
                            if(a.tipo > b.tipo)
                                return -1;
                            else if(a.tipo < b.tipo)
                                return 1;
                            else
                                return 0;
                        })
                    });

                    this.lista = [];
                    this.lista.push(raiz);
                },
                err => {
                    this.$swal('Aviso', err.response.data, 'error')
                }
            );
        }
    }
}
</script>

<style scoped>
    .cabecalho {
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 70px;
        z-index: 5;
    }
</style>
